import { Action } from "redux";
import { AuthFailReason } from "../../../model/AuthFailReason";

export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";

export interface AuthLoginFailAction extends Action {
  type: typeof AUTH_LOGIN_FAIL;
  reasons: Array<{
    code: AuthFailReason;
  }>;
}

export const authLoginFailAction = (
  reasons: Array<{ code: AuthFailReason }> = []
): AuthLoginFailAction => ({
  type: AUTH_LOGIN_FAIL,
  reasons,
});
